// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5360":"25703f3a","5780":"25703f3a"}[chunkId] + ".chunk.css";
};